import {
  AfterViewInit,
  Directive,
  inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  ListView,
  ListViewProviderDirective,
  log,
  UIComponents,
  ViewWindow
} from '@ntap/core';
import {
  first,
  map,
  Observable,
  Subject,
  switchMap,
  takeUntil,
  tap
} from 'rxjs';
import { FIZICKI_OBJEKT_PARENT_ITEM } from '../pojavni-oblik/pojavni-oblik.component';

@Directive()
export abstract class RazmjestiComponent
  implements AfterViewInit, OnInit, OnDestroy
{
  @Input()
  razmjestiActionName: string;
  @Input()
  razmjestiListName: string;

  INIT_COMP_ID = UIComponents.LISTVIEW;

  private itemViewProvider = inject(FIZICKI_OBJEKT_PARENT_ITEM);
  private listViewProvider = inject(ListViewProviderDirective);
  private window: ViewWindow | null = inject(ViewWindow, { optional: true });
  private fizickiObjektiOdabraniZaRazmjestanje$: Observable<any>;
  private destroy = new Subject<boolean>();

  disabled$: Observable<boolean>;
  @ViewChild(ListViewProviderDirective<ListView>)
  listaObjekataKojeRazmjestamo: ListViewProviderDirective<ListView>;

  currentListViewName: string;
  currentListViewState: object;
  currentListViewStateFilter: object = {};

  ngAfterViewInit(): void {
    this.fizickiObjektiOdabraniZaRazmjestanje$ =
      this.listaObjekataKojeRazmjestamo.selectedItems$;
    this.disabled$ = this.fizickiObjektiOdabraniZaRazmjestanje$.pipe(
      map((selected: string | any[]) => selected.length === 0)
    );
  }

  razmjestFizickeObjekteIzVisihRazina() {
    this.fizickiObjektiOdabraniZaRazmjestanje$
      .pipe(
        first(),
        switchMap((fizickiObjektiOdabraniZaRazmjestanje) => {
          const actionParams = {
            $selected: fizickiObjektiOdabraniZaRazmjestanje
          };
          return this.listViewProvider.executeAction(
            this.razmjestiActionName,
            actionParams
          );
        }),
        tap(() => {
          this.listViewProvider.refresh();
          this.window && this.window.close();
        })
      )
      .subscribe();
  }

  ngOnInit() {
    this.itemViewProvider.item$
      .pipe(takeUntil(this.destroy))
      .subscribe((parentItem) => {
        log('param change');
        this.changeView(this.razmjestiListName, parentItem);
      });
  }

  changeView(viewName: string, parentItem: any) {
    log(`CHANGE NEW view: ${viewName}`);
    this.currentListViewName = viewName;
    this.currentListViewState = {
      $parentJedinicaId: parentItem['en~pojavni_oblik~jedinica_gradiva_id'],
      $parentPojavniOblikId: parentItem['en~pojavni_oblik~id'],
      $itemType: 'en~jedinica_gradiva',
      $parentType: 'en~jedinica_gradiva'
    };
    this.currentListViewStateFilter = {};
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
  }
}
